import React, { useEffect, useMemo, useState } from "react";
import { Modal, Input, Radio, Button, Space, Typography, Spin } from "antd";
import "./index.less";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/redux/reducer/store";
import {
    updateAddOrShowFavouritesModel,
    updateAuthorCode,
    updateCommonErrorMessage,
    updateCommonSuccessMessage,
    updateCommonWarnMessage,
    updateCurrentTab,
    updateNeedClearDrawMap,
    updateSelectedFavoriteInfo
}
    from "@/redux/actions/lightningAction";
import { LightningAddOrShowFavouritesEnum, LightningSearchTypeEnum, LightningTabsEnum, LigntningFavouritesEnum } from "@/util/cosntants";
import IF from "@/components/IF";
import { isExistsAuthorCode, operateFavorite } from "@/util/http/Lightning";
import { debounce } from "lodash";
import { IFavoriteModel, IGetCountriesTreeResModel } from "@/util/http/Lightning/responseType";
import deleteImg from "@/resource/images/png/lightning/Delete.png";
import leftArrow from "@/resource/images/png/lightning/left-arrow.png";

const { Title } = Typography;
const FavouritesModal = (props: any) => {

    const dispatch = useDispatch();

    const handleCancel = () => {
        dispatch(updateAddOrShowFavouritesModel(null));
    };

    /**
     * For Add
     * 1. if no author code, then should show input box to input author code
     * 2. if author code is exist, show input box to input favourites name
     *
     * For Show
     * 1. if no author code, then should show input box to input author code
     *    then check if author code is exist, if exist, then show tooltip for code match, though show code new tootip
     *    then click process button, should get all favourites list
     * 2. if author code is exist, then show all favourites list
     *
     * 3. provide a return button to return input page
     */

    const isShowFavouritesModal = useSelector((state: RootState) => state.lightningReducer.isShowFavouritesModal);
    const addOrShowFavouritesModal = useSelector((state: RootState) => state.lightningReducer.addOrShowFavouritesModal);
    const authorCode = useSelector((state: RootState) => state.lightningReducer.authorCode);
    const favouritesOptions = useSelector((state: RootState) => state.lightningReducer.favouritesOptions);
    const [inputAuthorCode, setInputAuthorCode] = React.useState<string>("");

    const [ifExistAuthorCode, setIfExistAuthorCode] = React.useState<boolean | undefined>(undefined);

    const [favouritesName, setFavouritesName] = React.useState<string>("");
    const [allFavoriteList, setAllFavoriteList] = React.useState<IFavoriteModel[]>([]);

    // for show all Favourites

    const publicHandleProcess = async () => {
        if (addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.SHOW && inputAuthorCode) {
            console.log("publicHandleProcess: 开始获取收藏列表");
            localStorage.setItem("authorCode", inputAuthorCode);
            dispatch(updateAuthorCode(inputAuthorCode));

            // 关键修复：使用await等待数据获取完成
            await publicGetAllFavouritesList(inputAuthorCode);
        }

        // for Add
        if (addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.ADD) {
            if (!authorCode || !favouritesName) {
                // mean should add a new Favourites
                // handle show Favourites, mean should get all Favourites list
                localStorage.setItem("authorCode", inputAuthorCode);
                dispatch(updateAuthorCode(inputAuthorCode));
            }
            else if (authorCode && favouritesName) {
                // mean should add a new Favourites
                try {
                    const res = await operateFavorite({
                        operation: LigntningFavouritesEnum.ADD,
                        authorCode: authorCode,
                        name: favouritesName,
                        options: favouritesOptions,
                    });
                    dispatch(updateAddOrShowFavouritesModel(null));
                    dispatch(updateCommonSuccessMessage("Saved to Favourites successfully!"));
                } catch (error) {
                    dispatch(updateCommonWarnMessage("Save failed. The entered name already exists."));
                }
            }
        }

    };

    const publicHandleReturn = () => {
        // handle return, mean should return to input author code page
        setInputAuthorCode("");
        setIfExistAuthorCode(undefined);
        setFavouritesName("");
        dispatch(updateAuthorCode(""));
        localStorage.removeItem("authorCode");
    };

    // 防抖后的函数，假设这个函数在组件或模块中使用
    const publicHandleAuthorCodeInput = debounce(async (value?: string) => {
        setInputAuthorCode(value || "");
        try {
            const res = await isExistsAuthorCode(value);
            setIfExistAuthorCode(res.data);
        } catch (e) {
            console.error("Error checking author code existence:", e);
        }
    }, 30);

    const publicHandleInput = (value?: string) => {
        if (addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.ADD) {
            setFavouritesName(value || "");
        }
        else if (addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.SHOW) {
            // handle show Favourites, mean should get all Favourites list
            dispatch(updateAuthorCode(value || ""));
        }
    };

    const [isLoading, setIsLoading] = useState(false);
    const publicGetAllFavouritesList = async (authorCode: string) => {
        setIsLoading(true);
        try {
            const res = await operateFavorite({
                operation: LigntningFavouritesEnum.SEARCH,
                authorCode: authorCode,
            });
            if (res?.data?.length > 0) {
                console.log("before update allFavoriteList:", allFavoriteList);
                setAllFavoriteList(res.data);
                setSearchQuery("");
                console.log("after update allFavoriteList:", res.data);
            } else {
                setAllFavoriteList([]);
                console.log("get empty");
            }
        }
        catch (e) {
            console.error("Error getting all Favourites list:", e);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        if (addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.SHOW ||
            addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.ADD) {
            // get author code
            const tmpAuthorCode = localStorage.getItem("authorCode");
            if (tmpAuthorCode) {
                dispatch(updateAuthorCode(tmpAuthorCode));
                // if is show, the should get all favourites list
                if (addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.SHOW) {
                    publicGetAllFavouritesList(tmpAuthorCode);
                }
            }
        }
        // if author code is exist, then set inputAuthorCode
        if (addOrShowFavouritesModal !== LightningAddOrShowFavouritesEnum.SHOW &&
            addOrShowFavouritesModal !== LightningAddOrShowFavouritesEnum.ADD) {
            setInputAuthorCode("");
            setIfExistAuthorCode(undefined);
            setFavouritesName("");
        }
    }, [addOrShowFavouritesModal, authorCode]);

    const [selectedId, setSelectedId] = useState<number | null>(null);
    const handleDelete = async (item) => {
        try {
            const res = await operateFavorite({
                operation: LigntningFavouritesEnum.DELETE,
                authorCode: item?.authorCode,
                id: item?.id,
                name: item?.name
            });

            setAllFavoriteList(prev => prev.filter(fav => fav.id !== item.id));

            setSearchQuery("");
            dispatch(updateCommonSuccessMessage("Favourites Name Deleted Successfully!"));
        } catch (error) {
            dispatch(updateCommonWarnMessage("Failed to delete favorite"));
        }
    };

    const [searchQuery, setSearchQuery] = useState("");

    const filteredFavoriteList = useMemo(() => {
        if (!searchQuery.trim()) return allFavoriteList;
        const query = searchQuery.toLowerCase().trim();
        return allFavoriteList.filter(item =>
            item.name.toLowerCase().includes(query)
        );
    }, [allFavoriteList, searchQuery]);

    const handleOpen = () => {
        // 检查是否已选择收藏项
        console.log("selectedId", selectedId);
        if (selectedId === null) {
            dispatch(updateCommonWarnMessage("Please select a favorite first"));
            return;
        }
        const selectedFavorite = allFavoriteList.find(item => item.id === selectedId);
        if (!selectedFavorite) {
            dispatch(updateCommonWarnMessage("Selected favorite not found"));
            return;
        }
        dispatch(updateSelectedFavoriteInfo(selectedFavorite));
        switch (selectedFavorite?.options?.currentTab) {
            case LightningTabsEnum.LOCATION:
                dispatch(updateCurrentTab(LightningTabsEnum.LOCATION));
                break;
            case LightningTabsEnum.Region:
                dispatch(updateCurrentTab(LightningTabsEnum.Region));
                break;
            case LightningTabsEnum.DRAWONMAP:
                dispatch(updateCurrentTab(LightningTabsEnum.DRAWONMAP));
                break;
            default:
                dispatch(updateCurrentTab(LightningTabsEnum.LOCATION));
        }
        handleCancel();
    };
    return (
        <Modal
            // title="Favourites"
            title={
                <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                    <IF show={!!authorCode && (addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.SHOW ||
                        addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.ADD
                    )}>
                        <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                            onClick={() => {
                                publicHandleReturn();
                            }}>
                            <img src={leftArrow} />
                        </div>
                    </IF>
                    <Title level={4} style={{ margin: 0 }}>
                        Favourites
                    </Title>
                </div>
            }
            open={addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.SHOW ||
                addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.ADD
            }
            // onOk={handleOk}
            onCancel={handleCancel}
            width={360}
            className="lightning-favourites-modal"
            footer={null}
            getContainer={() => document.getElementById("lightning-component") as HTMLElement}
        >
            <div className="lightning-favourites-modal-content">
                <div className="lightning-favourites-modal-content-enter">

                    {/* 只有为 show，并且 author 为值时，会是这里 */}
                    <Spin spinning={isLoading}>
                        <IF show={!!authorCode && addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.SHOW}>
                            {/* then show all Favourites list */}
                            <div className="favourite-search-container">
                                <Input
                                    type="text"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="favourite-search-input"
                                />
                            </div>
                            {/* 根据搜索结果筛选后的收藏列表 */}
                            {filteredFavoriteList.length > 0 ? (
                                <Radio.Group
                                    value={selectedId}
                                    onChange={(e) => setSelectedId(e.target.value)}
                                    style={{ display: "flex", flexDirection: "column" }}
                                >
                                    {filteredFavoriteList.map((item) => (
                                        <div
                                            key={item.id}
                                            className="favourite-list"
                                        >
                                            <Radio value={item.id}>{item.name}</Radio>
                                            <img
                                                src={deleteImg}
                                                alt="Delete"
                                                style={{ marginLeft: "auto", cursor: "pointer" }}
                                                onClick={(e) => {
                                                    e.stopPropagation(); // 防止触发Radio选择
                                                    handleDelete(item);
                                                }}
                                            />
                                        </div>
                                    ))}
                                </Radio.Group>
                            ) : (
                                <div className="lightning-favourites-modal-content-enter-author-code-list">
                                    {searchQuery ? "No relevant favourites found" : "No Favourites Found"}
                                </div>
                            )}
                        </IF>
                    </Spin>

                    {/* 假如 author 有值，且是 Add，则直接进输入名字的 */}
                    <IF show={!!authorCode && addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.ADD}>
                        <div className="lightning-favourites-modal-content-enter-author-code">
                            Enter Favourites Name
                        </div>
                        {/* For add Favourites */}
                        <Input
                            value={favouritesName}
                            onChange={(e) => {
                                publicHandleInput(e.target.value);
                            }}
                        />
                    </IF>

                    {/* 假如 author 没值 */}
                    <IF show={!authorCode}>
                        <Input
                            value={inputAuthorCode}
                            onChange={(e) => {
                                publicHandleAuthorCodeInput(e.target.value);
                            }}
                            placeholder="Define Username"
                        />
                        <div style={{ marginTop: "10px", marginBottom: "10px", color: "green" }}>
                            {
                                ifExistAuthorCode === undefined ? "" :
                                    (ifExistAuthorCode === true ? "Name match" : "Name new")
                            }
                        </div>
                    </IF>

                </div>


                {/* Button */}
                <div>
                    <div className="lightning-favourites-modal-content-button">
                        <IF show={!(!!authorCode && addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.SHOW)
                        }>
                            <div className="lightning-favourites-modal-content-button-item favourites-invoke"
                                onClick={() => {
                                    publicHandleProcess();
                                }}
                            >
                                Proceed
                            </div>
                        </IF>
                        <IF show={!!authorCode && (addOrShowFavouritesModal === LightningAddOrShowFavouritesEnum.SHOW)}>
                            <div className="lightning-favourites-modal-content-button-item favourites-invoke"
                                onClick={() => {
                                    handleOpen();
                                }}
                            >
                                Open
                            </div>
                        </IF>
                        <div className="lightning-favourites-modal-content-button-item favourites-cancel"
                            onClick={() => {
                                handleCancel();
                            }}
                        >
                            Cancel
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default FavouritesModal;